/**
 * 计算时间差值
 * @param {Number} t1 当前时间13位时间戳
 * @param {Number} t2 数据存入时间13位时间戳
 */
export function trans (t1, t2) {
  let ret = '刚刚'
  const diff = t1 - t2
  const d = diff / 86400000
  const h = diff / 3600000
  const m = diff / 60000
  if (d >= 1) {
    ret = `${Math.round(d)}天前`
    return ret
  } else if (h >= 1) {
    ret = `${Math.round(h)}小时前`
    return ret
  } else if (m >= 5) {
    ret = `${Math.round(m)}分钟前`
    return ret
  }
  return ret
}



// WEBPACK FOOTER //
// ./src/utils/timeTrans.js